export default class EnumHelper {
    static GetDescription(e, id) {
        return e[e[id].toString() + "Desc"];
    }
}
